import TextEditor from 'app/form/TextEditor';
import React from 'react';

const PrivacyPolicySection = () => {
	return (
		<div>
			<TextEditor />
		</div>
	);
};

export default PrivacyPolicySection;
